// Sub1 subscription product groups

import EmberObject, { computed } from '@ember/object';
import { and } from '@ember/object/computed';
import { notNone } from '@square/dashboard-utilities/macros';

// eslint-disable-next-line ember/no-classic-classes
export default EmberObject.extend({
  init() {
    this._super();
    if (!this.subscriptions) {
      this.set('subscriptions', []);
    }
  },
  productGroup: null,
  isVisible: notNone('subscriptionToShow'),
  subscriptionToShow: computed('pendingSubscription', 'activeSubscription', 'delinquentSubscription', 'inGrace', 'lowestTier.isVisible', function () {
    return this.pendingSubscription || this.activeSubscription || this.inGrace || this.delinquentSubscription || (this.lowestTier?.isVisible ? this.lowestTier : undefined);
  }),
  activeSubscription: computed('subscriptions.@each.statusIsActive', function () {
    return this.subscriptions.findBy('statusIsActive');
  }),
  activeButCanceledSubscription: computed('subscriptions.@each.activeButCanceled', function () {
    return this.subscriptions.findBy('activeButCanceled');
  }),
  pendingSubscription: computed('subscriptions.@each.hasFutureStartDate', function () {
    return this.subscriptions.findBy('hasFutureStartDate');
  }),
  delinquentSubscription: computed('subscriptions.@each.statusIsDelinquent', function () {
    return this.subscriptions.findBy('statusIsDelinquent');
  }),
  inGrace: computed('subscriptions.@each.statusIsInGrace', function () {
    return this.subscriptions.findBy('statusIsInGrace');
  }),
  lowestTier: computed('subscriptions.@each.lowestTier', function () {
    return this.subscriptions.findBy('lowestTier');
  }),
  isPendingDowngrade: and('activeButCanceledSubscription', 'pendingSubscription')
}).reopenClass({
  createFromSubscriptions(subscriptions) {
    if (subscriptions.length <= 0) {
      return null;
    }
    return this.create({
      subscriptions,
      productGroup: subscriptions[0].get('productGroup')
    });
  }
});